import styled from 'styled-components'
import theme from '../theme.js'

const StyledSlatOuter = styled.section`
  margin: auto;
  overflow: hidden;
  font-family: ${theme.baseFont};
  font-weight: normal;
  width: 100%;
  box-shadow: rgba(32,32,32,0.05) 0px 0px 30px 0px;
  @media (min-width: ${theme.xlarge.inner}) {
    max-width: ${theme.xlarge.outer};
  };
`

export default StyledSlatOuter


// WEBPACK FOOTER //
// ./src/components/StyledSlatOuter.js